import { requestUpload } from 'utils/api';
import config from 'config';
import { UploadImagePayload } from 'utils/apiClient/services/inventory/types';

/* eslint-disable import/prefer-default-export */
export async function uploadImage(
  payload: UploadImagePayload,
  userToken: string
): Promise<any> {
  const url = `${config.CORE_URL}/api/images/`;
  const formData = { image: payload.file, type: payload.type };
  return requestUpload({
    url,
    userToken,
    requestData: formData,
  });
}
